document.querySelectorAll( '.b-products-listing' ).forEach( ( block ) => {

	const tabs = block.querySelectorAll( '.c-tabs-list-item' );
	if ( !tabs.length ) {

		return;

	}
	const currentButton = block.querySelector( '.c-tabs-list__current' );
	const dropdown = block.querySelector( '.c-tabs-list__buttons' );
	const tabsContainer = block.querySelector( '.c-tabs-list' );

	if ( !currentButton || !dropdown || !tabsContainer ) {

		return;

	}
	const currentButtonText = currentButton.querySelector( '.js-current' );
	if ( !currentButtonText ) {

		return;

	}

	/**
	 * Sets the custom height property of a dropdown element.
	 * Retrieves the scroll height of the dropdown element and sets the custom CSS property '--dropdown-height' with this value.
	 */
	const setDropdownHeight = () => {

		dropdown.style.removeProperty( '--dropdown-height' );
		dropdown.style.setProperty( '--dropdown-height', `${ dropdown.scrollHeight }px` );

	}

	/**
	 * Function to close the dropdown by removing 'is-active' class from the current button and dropdown element.
	 */
	const closeDropdown = () => {

		currentButton.classList.remove( 'is-active' )
		dropdown.classList.remove( 'is-active' );

	}



	/**
	 * Handles the click event on a dropdown button to toggle its active state.
	 * @param {Event} event - The event object triggered by the click event.
	 */
	const handleDropdownClick = ( event ) => {

		const button = event.target.closest( '.c-tabs-list__current' );
		if ( !button ) {

			return


		}

		button.classList.toggle( 'is-active' )
		dropdown.classList.toggle( 'is-active' )

	};

	/**
	 * Handle click event on the body element to close dropdown if target is outside of the tabs container.
	 * @param {Event} e - The click event object.
	 */
	const handleBodyClick = e => {

		if ( e.target && !tabsContainer.contains( e.target ) ) {

			closeDropdown()

		}

	};

	document.addEventListener( 'DOMContentLoaded', () => {

		requestAnimationFrame( () => {

			setDropdownHeight()

		} );

	} );

	block.addEventListener( 'keydown', ( e ) => {

		if ( e.key === 'Escape' || e.key === 'Esc' ) {

			closeDropdown();

		}

	} );
	window.addEventListener( 'resize', () => {

		setDropdownHeight()

	} );


	document.body.addEventListener( 'click', handleBodyClick )
	block.addEventListener( 'click', handleDropdownClick );

} );
